export default __webpack_public_path__ + "static/media/him.02c87a91.jpg";